import { Directive, Output, HostListener, EventEmitter, Input , OnInit } from '@angular/core';

@Directive({
  selector: '[appSingleDragDrop]',
})
export class SingleDragDropDirective {

    @Output() dropHandler: EventEmitter<any> = new EventEmitter<any>();

    public dragging: boolean;
    public loaded: boolean;
    public imageLoaded: boolean;
    public imageSrc: string;
    public invalidFlag: boolean;


    @HostListener('dragover') onDragOver() {
        return false;
    }
    @HostListener('dragenter') handleDragEnter() {
        this.dragging = true;
    }
    @HostListener('dragleave') handleDragLeave() {
        this.dragging = false;
    }
    @HostListener('drop', ['$event']) handleDrop(e) {
        e.preventDefault();
        this.dragging = false;
        this.handleInputChange(e);
    }

    OnInit() {
        console.log('initialized');
    }

    handleInputChange(e) {
      return this.dropHandler.emit({ event: e, invalidFlag: this.invalidFlag });
    }
    handleReaderLoaded(e) {
        const reader = e.target;
        this.imageSrc = reader.result;
        this.loaded = true;
        this.dropHandler.emit({ event: e, invalidFlag: this.invalidFlag });
    }
}
